<script setup>
import ShowGridTile from './show-grid-tile'

defineProps({
    shows: {
        type: Array,
        default: () => [],
    },
    scroll: {
        type: Boolean,
        default: false,
    },
    scrollMobileOnly: {
        type: Boolean,
        default: false,
    },
    padded: {
        type: Boolean,
        default: false,
    },
})
</script>

<template>
    <div
        :class="[
            'show-grid-block',
            scroll && 'show-grid-block-scroll',
            scrollMobileOnly && 'show-grid-block-scroll-mobile-only',
            padded && 'show-grid-block-padded',
        ]"
    >
        <div
            v-for="(show, index) in shows"
            :key="show.id + index"
            class="tile"
        >
            <ShowGridTile :show="show" />
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import '@design';

.show-grid-block {
    display: flex;
    flex-wrap: wrap;
    margin-right: -$size-grid-padding;
    margin-left: -$size-grid-padding;

    &-padded {
        @include sidePadding;
    }
}

.tile {
    flex-basis: 50%;
    padding: 0 $size-grid-padding;
    margin-bottom: $size-grid-padding * 2;

    @include tablet {
        flex-basis: 50%;
    }

    @include desktop {
        flex-basis: 25%;
    }
}

.show-grid-block-scroll {
    @include scrollableWrapper;

    &-mobile-only {
        padding: 0;

        .tile {
            box-sizing: content-box;
            flex-basis: 70%;

            &:first-of-type {
                margin-left: $size-grid-padding * 2;
            }

            &:last-of-type {
                padding-right: $size-grid-padding * 3;
            }

            @include tablet {
                flex-basis: 50%;
            }

            @include desktop {
                box-sizing: border-box;
                flex-basis: 25%;

                &:first-of-type {
                    margin-left: 0;
                }

                &:last-of-type {
                    padding-right: $size-grid-padding;
                }
            }
        }

        @include desktop {
            flex-wrap: wrap;

            &.show-grid-block-padded {
                @include sidePadding;
            }
        }
    }
}
</style>
